<!-- <template>
  <div>
    <NavBarInicio />
    <div style="margin: 4rem auto 0;max-width: 80rem; position:relative;">
      <v-container grid-list-md style="padding-top:70px;">
        <v-layout row d-flex align-start justify-start>
          <v-flex
            v-for="(componente, index) in JSON.parse(this.componentes)">
            <CardModulos :title="componente.nombre" :detalle_titulo="componente.descripcion" :icono="componente.icono" :url="componente.ruta" />
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import CardModulos from "../components/cards/CardModulos.vue";
import NavBarVertical from "../components/navbar/NavBarVertical.vue";
import NavBarInicio from "../components/navbar/NavBarInicio.vue";

export default {
  data() {
    return {
      dialog: false,
      perfil: "",
      nombre: "",
      idUsuario:null,
      componentes: []
    };
  },
  mounted() {
  },
  created() {
    this.perfil = sessionStorage.getItem("perfil");
    this.nombre = sessionStorage.getItem("nombre");
    this.idUsuario = sessionStorage.getItem("idUsuario");
    this.componentes = sessionStorage.getItem("componentes");
  },
  methods: {
    actionOut() {
      this.dialog = false;
      this.$router.push("/");
    },
  },
  components: {
    NavBarInicio,
    CardModulos,
    NavBarVertical,
  },
};
</script>
<style scoped>
 ::v-deep .row {
      display: flex;
      flex-wrap: wrap !important;
      flex: 1 1 auto;
      margin: -12px;
  }

  ::v-deep  .layout {
      flex-wrap: wrap !important;
  }
  .v-application--wrap {
    padding-top: 58px !important;
  }

  .v-app-bar {
    position: fixed !important;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000 !important; /* asegúrate que sea mayor que el contenido */
  }

  .v-application--wrap {
    padding-top: 70px !important; /* mismo alto que tu navbar */
  }
</style> -->

<template>
  <div>
    <NavBarInicio />
    
    <div class="dashboard-container">
      
      <div class="search-bar-wrapper">
        <v-text-field
          v-model="searchText"
          label="Buscar módulo..."
          solo
          flat
          dense
          prepend-inner-icon="mdi-magnify"
          class="search-input"
        ></v-text-field>
      </div>

      <v-container class="modules-grid-container">
        <div v-for="(group, groupName) in filteredGroupedComponents" :key="groupName" class="module-group">
          
          <h2 class="group-title">{{ groupName }}</h2>

          <div class="cards-grid">
            <CardModulos 
              v-for="componente in group" 
              :key="componente.nombre"
              :title="componente.nombre" 
              :detalle_titulo="componente.descripcion" 
              :icono="componente.icono" 
              :url="componente.ruta" 
            />
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import CardModulos from "../components/cards/CardModulos.vue";
// NavBarVertical no parece usarse en esta vista.
import NavBarInicio from "../components/navbar/NavBarInicio.vue";

export default {
  data() {
    return {
      dialog: false,
      perfil: "",
      nombre: "",
      idUsuario: null,
      componentes: [], // Lista sin procesar de módulos
      searchText: "",  // Nuevo estado para la búsqueda
    };
  },
  
  created() {
    this.perfil = sessionStorage.getItem("perfil");
    this.nombre = sessionStorage.getItem("nombre");
    this.idUsuario = sessionStorage.getItem("idUsuario");
    const comps = sessionStorage.getItem("componentes");
    
    if (comps) {
      // ⚠️ IMPORTANTE: Aquí deberías asignar un campo 'grupo' 
      // si tus datos no lo tienen, o modificar la lógica de agrupamiento.
      // Por ahora, solo parseamos el JSON.
      this.componentes = JSON.parse(comps).map(c => ({
          ...c,
          // EJEMPLO: Asumiendo que tienes un campo 'grupo' en tu BD. 
          // Si no lo tienes, debes definir la lógica aquí (ver nota abajo).
          grupo: c.grupo || 'General', 
      }));
    }
  },
  
  methods: {
    actionOut() {
      this.dialog = false;
      this.$router.push("/");
    },
    
    // Función de ayuda para agrupar los módulos
    groupModules(modules) {
        return modules.reduce((acc, module) => {
            const groupKey = module.grupo;
            if (!acc[groupKey]) {
                acc[groupKey] = [];
            }
            acc[groupKey].push(module);
            return acc;
        }, {});
    }
  },
  
  computed: {
    // 1. Filtrar módulos basados en la búsqueda
    filteredComponents() {
      const search = this.searchText.toLowerCase().trim();
      if (!search) {
        return this.componentes;
      }
      return this.componentes.filter(c =>
        c.nombre.toLowerCase().includes(search) || 
        c.descripcion.toLowerCase().includes(search)
      );
    },
    
    // 2. Agrupar los módulos filtrados para la visualización por sección
    filteredGroupedComponents() {
        return this.groupModules(this.filteredComponents);
    }
  },
  
  components: {
    NavBarInicio,
    CardModulos,
  },
};
</script>

<style scoped>
.dashboard-container {
  margin: 0 auto;
  max-width: 80rem;
  padding: 5rem 1.5rem 2rem;
  box-sizing: border-box;
  width: 100%;
  overflow-x: hidden;
}

.search-bar-wrapper {
  max-width: 420px;
  width: 100%;
  margin-bottom: 0.5rem;
}

.search-input {
  background-color: #ffffff !important;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.group-title {
  font-size: clamp(1.15rem, 2.5vw, 1.5rem);
  font-weight: 600;
  color: #333;
  margin: 1.5rem 0 1rem;
  padding-bottom: 0.4rem;
  border-bottom: 2px solid #eee;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;
}

.modules-grid-container.v-container {
  padding: 0 !important;
  max-width: 100% !important;
}

.module-group {
  width: 100%;
}

/* Tablet landscape / desktop pequeño */
@media screen and (max-width: 1200px) {
  .cards-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Tablet */
@media screen and (max-width: 960px) {
  .dashboard-container {
    padding: 4.75rem 1rem 1.75rem;
  }

  .search-bar-wrapper {
    max-width: 100%;
  }

  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.85rem;
  }
}

/* Celular */
@media screen and (max-width: 600px) {
  .dashboard-container {
    padding: 4.5rem 0.75rem 1.5rem;
  }

  .group-title {
    margin: 1.15rem 0 0.75rem;
  }

  .cards-grid {
    grid-template-columns: 1fr;
    gap: 0.7rem;
    margin-bottom: 1.5rem;
  }
}

/* Celular chico */
@media screen and (max-width: 380px) {
  .dashboard-container {
    padding: 4.35rem 0.55rem 1.25rem;
  }
}
</style>